import { Factory } from './Factory'
import { SectionFactory } from './SectionFactory'
export class TabFactory extends Factory {
  constructor(qty = 1) {
    super()
    this.qty = qty
  }

  create(data) {
    this.tabs = this.mapTabs(data)
    let tabs = this.tabs.map(tab => {
      let id = this.id('section')
      return {...tab, id}
    })
    return tabs
  }

  mapTabs(data) {
    if (data) {
      return data
    }
    let tabs = []
    for (let x = 1; x <= this.qty; x++) {
      tabs.push(this.tabMarkup())
    }
    return tabs
  }

  tabMarkup() {
    let section = (new SectionFactory).create()[0]
    return {
      ...section,
      "content":{
        "title":"New Tab"
      }
    }
  }
}